import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    // Check if user is logged in by checking localStorage
    const isAuthenticated = () => {
        const userId = localStorage.getItem('user_id');
        return !!userId; // Returns true if user_id exists, false otherwise
    };

    useEffect(() => {
        // Double check authentication on mount and location change
        if (!isAuthenticated()) {
            // Clear any stale data
            localStorage.removeItem('user_id');
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_email');
            localStorage.removeItem('user_picture');
        }
    }, [location.pathname]);

    if (!isAuthenticated()) {
        // Redirect to login if not authenticated
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;

